export const API_CONFIG = {
  WEBHOOK_URL: import.meta.env.VITE_API_WEBHOOK_URL || '/api/pareceres',
  TOKEN: import.meta.env.VITE_API_TOKEN || '',
  // GOOGLE_API_KEY removido - agora apenas no backend por segurança
} as const;

